import { Icon } from '@neshane/blueberry';

import { useAuth } from '../../../modules/Authentication';

import './CompanyHeader.css';

const HeaderContent = ({ title }) => {
  return (
    <div className="navigation-company-header">
      <Icon
        name="buildings-office"
        className="navigation-company-content-shrink"
        aria-hidden="true"
      />
      <div className="navigation-company-content navigation-company-translate">
        <h1 className="break-words body-m">{title}</h1>
      </div>
    </div>
  );
};

export const CompanyHeader = () => {
  const { user } = useAuth();
  const title = user?.getFullName?.() || 'پنل کاربری';

  return <HeaderContent title={title} />;
};